import { packageName } from './../addon-constants';
const startMark = `${packageName}-start`;
const endMark = `${packageName}-end`;
export default async function mark(taskName, fn) {
    performance.mark(startMark);
    const result = await fn();
    performance.mark(endMark);
    performance.measure(`🚀 (Task: ${taskName})`, startMark, endMark);
    return result;
}
